module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl2-50.e89c42dd.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl2-50.png
// module id = 3529
// module chunks = 11